"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetZendeskToken = exports.createZendeskTokenFailure = exports.createZendeskTokenSuccess = exports.createZendeskTokenRequest = void 0;
const ActionTypes = require("../../actionTypes/auth/zendesk");
const createZendeskTokenRequest = () => ({
    type: ActionTypes.CREATE_ZENDESK_TOKEN_REQUEST
});
exports.createZendeskTokenRequest = createZendeskTokenRequest;
const createZendeskTokenSuccess = (token) => ({
    type: ActionTypes.CREATE_ZENDESK_TOKEN_SUCCESS,
    payload: token
});
exports.createZendeskTokenSuccess = createZendeskTokenSuccess;
const createZendeskTokenFailure = (payload) => ({
    type: ActionTypes.CREATE_ZENDESK_TOKEN_FAILURE,
    payload
});
exports.createZendeskTokenFailure = createZendeskTokenFailure;
const resetZendeskToken = () => ({
    type: ActionTypes.RESET_ZENDESK_TOKEN
});
exports.resetZendeskToken = resetZendeskToken;
//# sourceMappingURL=zendesk.js.map